module.exports = __webpack_public_path__ + "od-chevron-slider-left/od-chevron-slider-left-11357750ddb835a36a4a7cbd9676e12b.svg";